import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useReducedMotion } from "framer-motion";
import Landing from "../Pages/Landing";
import SplashScreen from "../Components/SplashScreen";
import { RootState } from "../Redux/store";

const SPLASH_DURATION_MS = 2200;
const REDUCED_MOTION_DURATION_MS = 700;

const RootEntry: React.FC = () => {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const prefersReducedMotion = useReducedMotion();
  const [splashComplete, setSplashComplete] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      setSplashComplete(false);
      return;
    }

    const timeout = window.setTimeout(
      () => setSplashComplete(true),
      prefersReducedMotion ? REDUCED_MOTION_DURATION_MS : SPLASH_DURATION_MS,
    );

    return () => window.clearTimeout(timeout);
  }, [isAuthenticated, prefersReducedMotion]);

  if (!isAuthenticated) return <Landing />;
  if (splashComplete) return <Navigate to="/home" replace />;

  return <SplashScreen />;
};

export default RootEntry;
